import { render, staticRenderFns } from "./AdminTipiContrattoView.vue?vue&type=template&id=1ac9298c&"
import script from "./AdminTipiContrattoView.vue?vue&type=script&lang=ts&"
export * from "./AdminTipiContrattoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports